var _defs, _g, _g2, _g3, _g4, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTaxonomynavigationlight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 594.78 68.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .navlhtcls-1, .navlhtcls-2 {\n        fill: #fff;\n      }\n\n      .navlhtcls-3 {\n        fill: #c2c4d8;\n      }\n\n      .navlhtcls-4, .navlhtcls-2 {\n        font-family: RobotoSlab-Regular, 'Roboto Slab';\n        font-size: 19.35px;\n      }\n\n      .navlhtcls-5 {\n        fill: #d9e6ea;\n      }\n\n      .navlhtcls-6 {\n        letter-spacing: 0em;\n      }\n\n      .navlhtcls-7 {\n        letter-spacing: -.02em;\n      }\n\n      .navlhtcls-8 {\n        fill: #f5fffa;\n      }\n\n      .navlhtcls-9 {\n        fill: #b4a7c5;\n      }\n\n      .navlhtcls-10 {\n        letter-spacing: 0em;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "navlhtcls-9",
    d: "M60.6,34.07c0-10.4,4.09-19.85,10.74-26.86H30.47C13.64,7.21,0,20.85,0,37.68H0c0,16.83,13.64,30.47,30.47,30.47h42.8c2.13,0,4.21-.22,6.22-.64-11.31-6.85-18.88-19.28-18.88-33.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "navlhtcls-1",
    d: "M18.06,50.42V31.39l12.69-9.52,12.69,9.52v19.03h-9.52v-11.1h-6.34v11.1h-9.52Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "navlhtcls-9",
    x: 65.6,
    y: 0,
    width: 194.03,
    height: 68.14,
    rx: 34.07,
    ry: 34.07
  }), /*#__PURE__*/React.createElement("text", {
    className: "navlhtcls-4",
    transform: "translate(86.93 40.13)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "navlhtcls-7",
    x: 0,
    y: 0
  }, "F"), /*#__PURE__*/React.createElement("tspan", {
    x: 11.7,
    y: 0
  }, "alconifor"), /*#__PURE__*/React.createElement("tspan", {
    className: "navlhtcls-6",
    x: 94.27,
    y: 0
  }, "m"), /*#__PURE__*/React.createElement("tspan", {
    x: 112.46,
    y: 0
  }, "es")))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "navlhtcls-3",
    x: 228.76,
    y: 0,
    width: 153.65,
    height: 68.14,
    rx: 34.07,
    ry: 34.07
  }), /*#__PURE__*/React.createElement("text", {
    className: "navlhtcls-4",
    transform: "translate(247.84 40.13)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "navlhtcls-7",
    x: 0,
    y: 0
  }, "F"), /*#__PURE__*/React.createElement("tspan", {
    x: 11.7,
    y: 0
  }, "alconidae")))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "navlhtcls-5",
    x: 355.86,
    y: 0,
    width: 105.61,
    height: 68.14,
    rx: 34.07,
    ry: 34.07
  }), /*#__PURE__*/React.createElement("text", {
    className: "navlhtcls-4",
    transform: "translate(374.88 40.13)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "navlhtcls-7",
    x: 0,
    y: 0
  }, "F"), /*#__PURE__*/React.createElement("tspan", {
    x: 11.7,
    y: 0
  }, "alco")))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "navlhtcls-2",
    transform: "translate(459.55 40.13)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "navlhtcls-10",
    x: 10.43,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    x: 21.09,
    y: 0
  }, "lumbarius")), /*#__PURE__*/React.createElement("rect", {
    className: "navlhtcls-8",
    x: 438.68,
    y: 0,
    width: 156.09,
    height: 68.14,
    rx: 34.07,
    ry: 34.07
  }), /*#__PURE__*/React.createElement("text", {
    className: "navlhtcls-4",
    transform: "translate(459.55 40.13)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "navlhtcls-10",
    x: 10.43,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    x: 21.09,
    y: 0
  }, "lumbarius")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxonomynavigationlight);
export default __webpack_public_path__ + "static/media/taxonomy navigation light.8a2afe8911bea10d9ce1c73e58c0f405.svg";
export { ForwardRef as ReactComponent };